<template>
<div id="toast" :class="{ show: isEnabled }">
  <h3>{{text}}</h3>
</div>
</template>

<script>
export default {
  props:{
    seconds: {
      type: Number,
      default: 3,
    },
  },

  data(){
    return {
      isEnabled: false,
      text: 'Default Toast test',
    }
  },

  methods: {
    show(givenText) {
        if(givenText != null){
          this.text = givenText
        }

        this.isEnabled = true
        setTimeout(() => { this.isEnabled = false }, this.seconds * 1000)
    },
  }
}
</script>

<style scoped>
#toast{
  visibility: hidden; /* Hidden by default. Visible on click */
  min-width: 250px; /* Set a default minimum width */
  margin-left: -125px; /* Divide value of min-width by 2 */
  background-color: var(--primary-color); /* Black background color */
  color: var(--primary-text-color); /* White text color */
  text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  padding: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  z-index: 1; /* Add a z-index if needed */
  left: 50%; /* Center the toast */
  bottom: 30px; /* 30px from the bottom */
}
#toast.show {
  visibility: visible; /* Show the toast */
  /* Add animation: Take 0.5 seconds to fade in and out the toast.
  However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}
/* Animations to fade the toast in and out */
@-webkit-keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}
@keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}
@-webkit-keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}
@keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}
</style>